<script lang="ts">
  import ExternalLink from "../../../icons/ExternalLink.svg"
  import type { RecommendedProduct } from "../../../interfaces/RecommendationProduct"
  import { recommendation } from "../../../stores/recommendation"

  export let product: RecommendedProduct

  function openProductPage () {
    recommendation.openProductPage(product)
  }
</script>

{#if $recommendation.details?.brand.storeCartUrl}
  <a
    href={product.url}
    target="_blank"
    class="product-name"
    on:click|preventDefault={openProductPage}
  >
    {product.name}
    <ExternalLink class="external-link" />
  </a>
{:else}
  <p class="product-name">
    {product.name}
  </p>
{/if}

<style lang="scss">
  a {
    :global(.external-link) {
      display: inline;
      fill: #747486;
      width: 10px;
      height: 24px;
      margin-left: 4px;
      vertical-align: top;
    }
  }
</style>
